import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { VueFactureAchatFicheContenuComponent } from '../vue-facture-achat-fiche-contenu/vue-facture-achat-fiche-contenu.component';
import { BarreMenusComponent, DonneesMenuItem, SimpleLibelleComponent } from '../../../../../../../val-ammon-composants/val-composants-lib/src/public-api';
import { ServicesParametresClient } from '../../../../../../../val-definitions-communes-lib/src/public-api';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe} from '@angular/common';

// Composant page pour afficher la fiche d'achat directement via URL
@Component(
  {
    selector: 'val-facture-achat-page',
    imports: [
      VueFactureAchatFicheContenuComponent,
      SimpleLibelleComponent,
      AsyncPipe,
      BarreMenusComponent
    ],
    templateUrl: './vue-facture-achat-page.component.html',
    styleUrls: ['./vue-facture-achat-page.component.scss']
  })
export class VueFactureAchatPageComponent {

  // Contenu de la fiche
  @ViewChild("ficheContenu")
  set ficheContenu(value: VueFactureAchatFicheContenuComponent | undefined) {
    if (!value) 
      return;
    this.ficheContenuComponent = value;
    queueMicrotask(() => {
      const achatId = this.route.snapshot.params['id'];
      value.ChargerDonnees(achatId);
    });
  }
  private ficheContenuComponent: VueFactureAchatFicheContenuComponent | undefined;

  // Indique si l'initialisation est terminée
  public initialisationTermine$: BehaviorSubject<boolean>;

  constructor(private route: ActivatedRoute, private servicesParametresClient: ServicesParametresClient) {
		this.initialisationTermine$ = new BehaviorSubject<boolean>(false);
  }

  async ngOnInit(): Promise<void> {
    await this.servicesParametresClient.ChargerParametresClient();

    this.initialisationTermine$.next(true);
  }

  public titre(): string {
    return this.ficheContenuComponent?.donnees?.titre ?? '';
  }

  public menuItems(): DonneesMenuItem[] {
    return this.ficheContenuComponent?.menuItems && !this.ficheContenuComponent.AucuneDonnee() ? this.ficheContenuComponent.menuItems : [];
  }
}
